import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { useCart } from '../context/CartContext';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiShoppingCart, FiMenu, FiX, FiCrosshair } = FiIcons;

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { cartCount, setIsCartOpen } = useCart();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Shop Tools', href: '#shop' },
    { name: 'Bundles', href: '#bundles' },
    { name: 'Steel Guide', href: '#compare' },
    { name: 'Care', href: '#care' }
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${
      scrolled ? 'glass-nav py-3 shadow-sm' : 'bg-transparent py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <a href="/" className="flex items-center gap-2 group">
          <SafeIcon icon={FiCrosshair} className={`text-2xl transition-colors ${scrolled ? 'text-red-600' : 'text-red-500'}`} />
          <span className={`font-black text-xl tracking-tighter transition-colors ${
            scrolled ? 'text-zinc-900' : 'text-white'
          }`}>
            FORGE & FORK
          </span>
        </a>
        
        <div className="hidden md:flex gap-10">
          {navLinks.map((link) => (
            <a 
              key={link.name}
              href={link.href} 
              className={`text-sm font-bold uppercase tracking-widest transition-colors hover:text-red-500 ${
                scrolled ? 'text-zinc-600' : 'text-white/90'
              }`}
            >
              {link.name}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-6">
          <button className={`p-2 transition-colors hover:text-red-500 ${scrolled ? 'text-zinc-900' : 'text-white'}`} aria-label="Search">
            <SafeIcon icon={FiSearch} className="text-xl" />
          </button>
          <button 
            onClick={() => setIsCartOpen(true)}
            className={`p-2 transition-colors hover:text-red-500 relative ${scrolled ? 'text-zinc-900' : 'text-white'}`}
            aria-label={`Shopping Cart with ${cartCount} items`}
          >
            <SafeIcon icon={FiShoppingCart} className="text-xl" />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] w-5 h-5 rounded-full flex items-center justify-center font-bold border-2 border-[#faf9f6]">
                {cartCount}
              </span>
            )}
          </button>
          <button 
            className={`md:hidden p-2 transition-colors ${scrolled ? 'text-zinc-900' : 'text-white'}`}
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open Menu"
          >
            <SafeIcon icon={FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 bg-zinc-950 z-[60] transition-transform duration-500 transform ${
        mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="p-6 flex justify-between items-center border-b border-white/10">
          <span className="text-white font-black text-xl tracking-tighter">MENU</span>
          <button onClick={() => setMobileMenuOpen(false)} className="text-white p-2">
            <SafeIcon icon={FiX} className="text-3xl" />
          </button>
        </div>
        <div className="flex flex-col p-8 gap-8">
          {navLinks.map((link) => (
            <a 
              key={link.name}
              href={link.href} 
              onClick={() => setMobileMenuOpen(false)}
              className="text-4xl font-black text-white hover:text-red-500 transition-colors tracking-tighter"
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}